import AssegneeSuggestionProvider from './AssegneeSuggestionContext';
import AssegneeSuggestion from "./AssegneeSuggestion"

let Index = () => {
    return (
        <AssegneeSuggestionProvider>
            <AssegneeSuggestion />
        </AssegneeSuggestionProvider>
    )
}

export default Index;